/** Pure constants + helpers for the gate panels — no React.
 *
 * Kept separate from RichGateBits.tsx so fast-refresh continues to work
 * across components.
 */

export const asArrayG = (v: unknown): unknown[] => (Array.isArray(v) ? v : []);
export const asTextG = (v: unknown): string => (typeof v === 'string' ? v : '');
export const objG = (v: unknown): Record<string, unknown> =>
  v && typeof v === 'object' ? (v as Record<string, unknown>) : {};

export const DECISION_CLS: Record<string, string> = {
  PROCEED: 'bg-green-50 text-green-700 border-green-200',
  PROCEED_WITH_WARNINGS: 'bg-amber-50 text-amber-800 border-amber-200',
  HUMAN_REVIEW_REQUIRED: 'bg-orange-50 text-orange-800 border-orange-300',
  RETRY: 'bg-red-50 text-red-800 border-red-300',
  REJECT: 'bg-red-50 text-red-800 border-red-300',
  APPROVED: 'bg-green-50 text-green-700 border-green-200',
  REVIEW: 'bg-amber-50 text-amber-800 border-amber-200',
};

export const VERDICT_CLS: Record<string, string> = {
  ...DECISION_CLS,
  EXECUTABLE: 'bg-green-50 text-green-700 border-green-200',
  ENFORCEABLE: 'bg-green-50 text-green-700 border-green-200',
  UNCERTAIN: 'bg-amber-50 text-amber-800 border-amber-200',
  NOT_ENFORCEABLE: 'bg-red-50 text-red-800 border-red-300',
  LOW: 'bg-green-50 text-green-700 border-green-200',
  MEDIUM: 'bg-amber-50 text-amber-800 border-amber-200',
  HIGH: 'bg-orange-50 text-orange-800 border-orange-300',
  CRITICAL: 'bg-red-50 text-red-800 border-red-300',
};

export const SEVERITY_CLS: Record<string, string> = {
  LOW: 'bg-green-50 text-green-700 border-green-200',
  MEDIUM: 'bg-amber-50 text-amber-800 border-amber-200',
  HIGH: 'bg-orange-50 text-orange-800 border-orange-300',
  CRITICAL: 'bg-red-50 text-red-800 border-red-300',
};
